import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const LINE_ITEMS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('LINE_ITEMS');
export const LINE_ITEMS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	LINE_ITEMS_CRUD_ACTION_CONSTANTS
);
